export const ModalTestAttributes = {
    xButtonE2eId: 'modal-x-button',
    confirmButtonE2eId: 'modal-confirm-button',
    cancelButtonE2eId: 'modal-cancel-button',
};
